import { ApolloQueryResult, gql } from '@apollo/client';
import { AddressType, applyUnsanitizedAddressLines, Coordinates } from '@buy-viasat/redux/src/address';
import { client } from 'shared/containers/apollo';
import { DateOfBirth, FormFieldState } from '../../../views/Checkout/types';
import { PerformCreditCheckResponse } from '@buy-viasat/types/build/bv';
import { Country, CustomerType } from '@buy-viasat/redux/src/app';

export type PerformCreditCheckPayload = ApolloQueryResult<{ performCreditCheck: PerformCreditCheckResponse }>;

export type PerformCreditCheckInput = {
  partyId: string;
  cartId: string;
  productId: string;
  lastFourOfSSN: FormFieldState<string>;
  dateOfBirth: DateOfBirth<string, string, string>;
  serviceAddress: AddressType;
  unsanitizedAddressLines: string[] | null;
  coordinates: Coordinates;
  network: boolean;
  dealerId?: string;
  partnerId?: string;
  taxId?: FormFieldState<string>;
  taxIdExternalName?: string;
  salesAgreementId: string;
  offerId: string;
  validatedClosingOfferId: string;
  customerType: CustomerType;
  country?: Country;
};

const PERFORM_CREDIT_CHECK = gql`
  query performCreditCheck($input: PerformCreditCheckInput!) {
    performCreditCheck(input: $input) {
      isEligible
      equifaxTransactionId
      creditTag
      installationFee
      feesAndDiscounts {
        fee
        discount
        total
        name
        kind
      }
    }
  }
`;

const performCreditCheckAsync = async (input: PerformCreditCheckInput): Promise<PerformCreditCheckPayload> => {
  const {
    partyId,
    cartId,
    productId,
    lastFourOfSSN,
    dateOfBirth,
    serviceAddress,
    unsanitizedAddressLines,
    coordinates,
    network,
    dealerId,
    partnerId,
    taxId,
    taxIdExternalName,
    salesAgreementId,
    offerId,
    validatedClosingOfferId,
    customerType,
    country,
  } = input;
  return client.query({
    fetchPolicy: network ? 'network-only' : 'cache-first',
    query: PERFORM_CREDIT_CHECK,
    variables: {
      input: {
        partyId,
        cartId,
        productId,
        ssn: lastFourOfSSN.value,
        taxId: taxId?.value,
        taxIdExternalName,
        dob: {
          month: dateOfBirth.month.value,
          day: dateOfBirth.day.value,
          year: dateOfBirth.year.value,
        },
        serviceLocation: {
          address: {
            ...applyUnsanitizedAddressLines(serviceAddress, unsanitizedAddressLines),
          },
          coordinates,
        },
        dealerId,
        partnerId,
        salesAgreementId,
        offerId,
        validatedClosingOfferId,
        customerType,
        country: country ?? Country.US,
      },
    },
  });
};

export default performCreditCheckAsync;
